"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.ButtonCloseModal = exports.customStyles = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#00000090',
    },
    content: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#DCE3E7',
        border: 'none',
        borderRadius: '0',
        padding: '1rem',
    },
};
exports.ButtonCloseModal = styled_components_1.default.button `
  align-self: flex-end;
  background-color: transparent;
  border: 1px solid #000;
  border-radius: 50%;
  height: 30px;
  width: 30px;

  &:before {
    content: 'X';
    color: #000;
    font-weight: 200;
    font-size: 1rem;
  }

  &:hover,
  &:focus {
    cursor: pointer;
  }
`;
exports.Title = styled_components_1.default.h2 `
  text-decoration: none;
  text-transform: capitalize;
  font-weight: 700;
  font-size: 1.5rem;
`;
